import * as React from 'react';
import { Box, Stack, Paper, Typography } from "@mui/material";
import ApiService from 'services/ApiService';
import { blue, red, grey } from '@mui/material/colors';


export const WeatherPaper = ({ sx }) => {
    const [shortermForecast, setShortermForecast] = React.useState()

    React.useEffect(() => {
        ApiService.get("newdashboard/integrated/GetWeather").then(response => {
            if (response.status === 200) {
                const data = response.data?.[0];
                if (data) {
                    const status = {
                        sky: data.sky,
                        tmp: data.tmp,
                        reh: data.reh,
                        rain: data.rain,
                        svg: ''  // svg 기본값
                    };

                    // sky 코드에 따라 svg 설정
                    switch (data.sky) {
                        case 1:
                            status.svg = "day";
                            break;
                        case 3:
                            status.svg = "cloudy-day-1";
                            break;
                        case 4:
                            status.svg = "cloudy";
                            break;
                        case 5:
                            status.svg = "rainy-5";
                            break;
                        case 6:
                            status.svg = "rainy-7";
                            break;
                        case 7:
                            status.svg = "snowy-5";
                            break;
                        case 9:
                            status.svg = "rainy-4";
                            break;
                        case 10:
                            status.svg = "rainy-2";
                            break;
                        case 11:
                            status.svg = "snowy-2";
                            break;
                        default:
                            status.svg = "unknown";
                            break;
                    }

                    setShortermForecast(status);
                }
            }
        })
    }, []);
    return (
        shortermForecast && (
                <div className='flx j_spc_btw a_center' style={{width: '100%', height:'100%'}}>
                    {/* 날씨 아이콘 */}
                    <div className='weatherBox flx flx_col'>
                        <p className='tit'>날씨</p>
                        <div className='flx a_center'>
                            <p className='txt' style={{marginRight:'20px'}}>
                                {shortermForecast.sky === 1 ? "맑음" :
                                    shortermForecast.sky === 3 ? "구름 많음" :
                                        shortermForecast.sky === 4 ? "흐림" :
                                            shortermForecast.sky === 5 ? "비" :
                                                shortermForecast.sky === 6 ? "비/눈" :
                                                    shortermForecast.sky === 7 ? "눈" :
                                                        shortermForecast.sky === 9 ? "빗방울" :
                                                            shortermForecast.sky === 10 ? "빗방울 눈날림" :
                                                                shortermForecast.sky === 11 ? "눈날림" :
                                                                        "날씨 정보 없음"}
                            </p>
                            <div style={{ width: '60px', height: '60px', position: 'relative' }}>
                                {shortermForecast.svg && (
                                    <img
                                        src={`/images/weather/animated/${shortermForecast.svg}.svg`}
                                        alt='weather'
                                        style={{
                                            width: '100%', height: '100%', position: 'absolute', top: '50%', left: '50%',
                                            transform: 'translate(-50%, -50%) scale(1.8)'
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>            
                    {/* 최고온도 / 최저온도 */}
                    <div className='weatherBox flx flx_col j_spc_btw'>
                        <p className='tit'>현재 기온</p>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Typography variant='h4' className='txt'>{shortermForecast.tmp}°</Typography>
                           
                        </div>
                    </div>
                    {/* 현재 기온 */}
                    <div className='weatherBox flx flx_col'>
                        <p className='tit'>습도</p>
                        <Typography variant='h3' className='txt'>{shortermForecast.reh}%</Typography>
                    </div>
                    <div className='weatherBox flx flx_col'>
                        <p className='tit'>강수량</p>
                        <Typography variant='h3' className='txt'>{shortermForecast.rain}</Typography>
                    </div>
                </div>
        )
    );
}